export default function MySQL_AUTOINCREMENT() {
  return (
    <div>
      <h2>MySQL_AUTOINCREMENT</h2>    </div>
  );
}